module.exports = __webpack_public_path__ + "static/media/loader.598c5800.svg";